import React from 'react';
import PropTypes from 'prop-types';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import PropertySelectorModal from '~components/property-selector-lazyload/modal';
import { propertyListingForm } from '~client/constants';

export default class PropertySelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      properties: props.properties,
      loading: !props.properties,
      showModal: false,
      modalIsOnTop: false,
    };
  }

  // this function will return a promise to tell what user does
  openToSelect = () => {
    if (!this.state.showModal) {
      this.toggleModal();
    }
    return new Promise(resolve => {
      this.selectCallback = properties => {
        if (properties) {
          resolve({ select: true, properties });
        } else {
          resolve({ select: false, properties: null });
        }
        this.selectCallback = null;
      };
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.properties !== this.props.properties) {
      this.setState({
        properties: nextProps.properties,
      });
    }
  }

  toggleModal = () => {
    if (!this.state.showModal) {
      const { top } = this.listElement.getBoundingClientRect();
      this.setState({
        showModal: true,
        modalIsOnTop: top > 300,
      });
    } else {
      this.setState({
        showModal: false,
      });
    }
  };

  handleSelectedChange = properties => {
    this.setState({
      showModal: false,
    });

    this.props.onChange(properties);
  };

  deleteProperty = slug => {
    const selectProperties = this.props.propertiesSelected.filter(property => {
      return slug !== property.slug;
    });

    this.props.onChange(selectProperties);
  };

  closeModal = () => {
    if (this.selectCallback) {
      this.selectCallback(null);
    }
    this.toggleModal();
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { propertiesSlugsExcluded, propertiesSelected, t, className, type } = this.props;

    return (
      <div className={`property-selector ${className}`}>
        <div
          className="property-selector__list"
          ref={list => {
            this.listElement = list;
          }}
        >
          <div className="property-selector__add" onClick={this.toggleModal} role="presentation">
            <PlusOutlined className="property-selector__add-icon" />
            <span>
              {type === 'property'
                ? t('cms.global.btn.select_property')
                : t('cms.global.btn.select_landlord')}
            </span>
          </div>
          <For each="selectedItem" of={propertiesSelected} index="idx">
            <If condition={selectedItem?.status !== propertyListingForm.statuses.published}>
              <div className="property-selector__item" key={selectedItem.slug}>
                <span>{selectedItem.name}</span>

                <CloseOutlined
                  onClick={() => {
                    this.deleteProperty(selectedItem.slug);
                  }}
                  className="property-selector__item-icon"
                />
              </div>
            </If>
            <If condition={selectedItem?.status === propertyListingForm.statuses.published}>
              <Tooltip placement="top" title={t('payment_plan_basic_info_property_tooltip')}>
                <div className="property-selector__item" key={selectedItem.slug}>
                  <span>{selectedItem.name}</span>
                </div>
              </Tooltip>
            </If>
          </For>
          <If condition={this.state.showModal}>
            <div
              className="property-selector__overlay"
              onClick={this.closeModal}
              role="presentation"
            />
            <PropertySelectorModal
              t={t}
              properties={this.state.properties}
              propertiesSelected={propertiesSelected}
              propertiesSlugsExcluded={propertiesSlugsExcluded}
              isOnTop={this.state.modalIsOnTop}
              onSubmit={this.handleSelectedChange}
              onFetchData={this.props.onFetchData}
              onSearch={this.props.onSearch}
              fetchLoading={this.props.fetchLoading}
              type={this.props.type}
            />
          </If>
        </div>
      </div>
    );
  }
}

PropertySelector.propTypes = {
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
      }),
    }),
  ),
  onFetchData: PropTypes.func,
  onSearch: PropTypes.func,
  propertiesSelected: PropTypes.array.isRequired,
  propertiesSlugsExcluded: PropTypes.array,
  t: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  fetchLoading: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.string,
};

PropertySelector.defaultProps = {
  t: () => {},
  properties: null,
  propertiesSelected: [],
  propertiesSlugsExcluded: [],
  onChange: () => {},
  onFetchData: () => {},
  onSearch: () => {},
  className: '',
  fetchLoading: false,
  onClose: () => {},
  type: 'property',
};
